export default __webpack_public_path__ + "static/media/vi_Grabado.19c7bb0a.mp4";